import { render, staticRenderFns } from "./BarChartVertical.vue?vue&type=template&id=153e7528&"
import script from "./BarChartVertical.vue?vue&type=script&lang=js&"
export * from "./BarChartVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports